import { TFunction } from '@lyearn/i18n';
import { TimeLimitApplicableOnEnum } from '@/types/schema';
import getHumanDuration from '@/utils/time/getHumanDuration';

import { QuizDetailsContentFragment } from '../../graphql/fragments/generated/QuizDetailsContent';

export const getQuizTimerDuration = (t: TFunction, content: QuizDetailsContentFragment) => {
  const i18nKey =
    content.settings?.timeLimitApplicableOn === TimeLimitApplicableOnEnum.Quiz
      ? 'QuizPlayer:QuizTime'
      : 'QuizPlayer:QuestionTime';

  return t(i18nKey, { time: getHumanDuration(content.settings?.timeLimit) });
};
